import { acceptHMRUpdate, defineStore } from 'pinia'
import { api } from 'boot/axios'
import { Cookies } from 'quasar'
import axios from 'axios'

const TOKEN_ENDPOINT = 'auth/token'
const REVOKE_ENDPOINT = 'auth/revoke'
const ME_ENDPOINT = 'admin/auth/me'
const SSO_ENDPOINT = 'admin/auth/sso'

const SHARED_DOMAIN = process.env.API_ENV === 'production' ? 'marciano.host' : 'marciano.dev'
const SHARED_COOKIE_OPTIONS = { path: '/', secure: true, domain: SHARED_DOMAIN }

const SESSION_COOKIES = ['auth_token', 'auth_token_life', 'auth_token_type']
const SHARED_COOKIES = ['auth_token', 'auth_token_console']

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isAuthenticated: false,
    me: {},
    ssoToken: {},
  }),
  getters: {
    isAdmin: (state) => state.me?.role === 'ADMIN',
    // La API nombra a los distribuidores como "Dealer <ciudad>",
    // pero de cara al usuario el sitio siempre es "Geely <ciudad>"
    siteName: (state) => {
      const name = String(state.me?.dealership?.name ?? '')
        .replace(/^dealer\s+/i, '')
        .trim()
      return name ? `Geely ${name}` : 'Geely'
    },
    // Nombre de la cuenta tal como se muestra en el menú y el encabezado
    accountLabel() {
      return this.isAdmin ? 'Corporativo' : this.siteName
    },
    roleLabel: (state) =>
      ({
        ADMIN: 'Administrador Geely',
        DEALERSHIP: 'Distribuidor',
      })[state.me?.role] || 'Consola de administración',
  },
  actions: {
    async login(data) {
      const response = await api({
        url: TOKEN_ENDPOINT,
        method: 'POST',
        data,
      })

      const options = {
        secure: process.env.PROD,
        expires: response.data.expiresAt,
        path: '/',
      }

      Cookies.set('auth_token', response.data.token, options)
      Cookies.set('auth_token_life', response.data.expiresAt, options)
      Cookies.set('auth_token_type', response.data.type, options)

      api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`

      this.isAuthenticated = true

      await this.fetchMe()

      return response
    },
    async logout(data) {
      try {
        return await api({
          url: REVOKE_ENDPOINT,
          method: 'POST',
          data,
        })
      } finally {
        this.clear()
      }
    },
    async fetchMe() {
      const response = await api({
        url: ME_ENDPOINT,
        method: 'GET',
      })
      this.me = response.data ?? {}
      return response
    },
    clear() {
      this.isAuthenticated = false
      this.me = {}

      SESSION_COOKIES.forEach((name) => Cookies.remove(name, { path: '/' }))
      Cookies.remove('refresh_token', { path: '/' })
      Cookies.remove('refresh_token_life', { path: '/' })
      SHARED_COOKIES.forEach((name) => Cookies.remove(name, SHARED_COOKIE_OPTIONS))

      delete api.defaults.headers.common['Authorization']
    },
    async sso(data) {
      const response = await axios({
        url: process.env.API_REFERIDOS + SSO_ENDPOINT,
        method: 'POST',
        data,
      })
      this.ssoToken = response.data

      this.clear()
      Cookies.set('auth_token', response.data.data.token, SHARED_COOKIE_OPTIONS)
      Cookies.set('auth_token_console', response.data.tokenConsole, SHARED_COOKIE_OPTIONS)

      return response
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot))
}
